import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, type LegalSection } from "@/components/legal/legal-layout";
import { usePolicy } from "@/lib/policies-store";
import { renderPolicyBody } from "@/lib/render-policy";
import { useLocalizedPolicy } from "@/lib/use-localized-policy";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy policy — Spayzo" },
      { name: "description", content: "How Spayzo collects, uses, and protects your personal information." },
      { property: "og:title", content: "Privacy policy — Spayzo" },
      { property: "og:description", content: "Our commitment to your privacy and data protection." },
    ],
    links: [{ rel: "canonical", href: "https://spayzo.lovable.app/privacy" }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  const doc = useLocalizedPolicy("privacy", usePolicy("privacy"));
  const sections: LegalSection[] = doc.sections.map((s) => ({
    id: s.id,
    title: s.title,
    body: renderPolicyBody(s.body),
  }));
  return (
    <LegalLayout
      title={doc.title}
      description={doc.description}
      updated={doc.updated}
      sections={sections}
      numbered={doc.numbered}
    />
  );
}
